<template>
  <div class="columns is-mobile is-centered mt-15">
    <div
      class="column is-full-mobile is-half-tablet is-two-third-desktop is-two-third-widescreen is-two-third-fullhd"
    >
      <div class="border-box rounded-border-box">
        <div>
          <div class="has-background-success padding-5">
            <h3 class="is-size-3 has-text-centered has-text-white">Order placed</h3>
            <h2 class="is-size-2 has-text-centered has-text-white">{{orderNumber}}</h2>
          </div>
          <p class="has-background-grey-lighter has-text-centered is-size-4 padding-5">
            <span
              v-if="!paymentTxn || (paymentTxn && paymentTxn.paymentStatus !== paymentStatusCodes[1])"
            >
              Pending payment
              <span
                class="ml-5"
                v-if="saleResponse"
                v-html="formatPrice(saleResponse.billRoundedAmount)"
              ></span>
            </span>
            <span
              v-if="paymentTxn && paymentTxn.paymentStatus === paymentStatusCodes[1]"
            >Payment completed</span>
          </p>
          <br />
          <div v-if="saleResponse" class="has-text-centered has-text-grey">
            <p
              class="is-size-6"
            >On further queries, contact the outlet {{ businessContact? 'at '+businessContact : '' }}</p>
          </div>
          <br />
          <!-- <div v-html="saleObj" class="padding-5"></div> -->
          <div class="buttons is-centered padding-5">
            <button
              class="button is-medium is-hidden"
              v-on:click="restart"
              v-if="!paymentTxn || (paymentTxn && (paymentTxn.paymentStatus === paymentStatusCodes[1] || paymentTxn.paymentStatus === paymentStatusCodes[2]))"
            >Order again</button>
            <button
              class="button is-medium"
              @click="displayBillLink"
              v-if="saleResponse && saleResponse.url && !resourceId"
            >View Bill</button>
          </div>
        </div>
      </div>
      <div v-if="seekNotificationPermission" class="border-box rounded-border-box mt-5 padding-5">
        <div class="level is-mobile">
          <div class="level-left">
            <div class="level-item">
              <p class="is-size-6">Do you want updates on this order?</p>
            </div>
          </div>
          <div class="level-right">
            <div class="level-item">
              <button class="button is-medium is-primary" @click="onSeekNotificationPermission">Ok</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import Constants from "@/util/constants";
import Util from "@/util";

export default {
  name: "OrderResult",
  data() {
    return {
      paymentStatusCodes: Constants.dataMap.paymentStatus,
      redirectTimeoutFn: null,
      redrTime: 30000,
      seekNotificationPermission: false
    };
  },
  computed: {
    ...mapState("cart", ["saleResponse", "paymentTxn"]),
    ...mapState("business", ["resourceId"]),
    ...mapGetters({
      businessContact: "business/businessContact"
    }),
    orderNumber() {
      if (!this.saleResponse) {
        return "";
      }
      return this.saleResponse.billNumber;
    },
    // saleObj () {
    //   const RL = window.RL

    //   if (this.saleResponse && RL) {
    //     delete this.saleResponse.billHeader
    //     delete this.saleResponse.billFooter
    //     try {
    //       return RL.bill.getDIV(this.saleResponse)
    //     } catch (error) {
    //       console.log(error)
    //     }
    //   }
    //   return 'No Sale.'
    // },
    isExternalPayment() {
      return this.paymentTxn && this.paymentTxn.extras;
    }
  },

  activated() {
    this.seekNotificationPermission = false;
    if ("Notification" in window && this.$messaging) {
      switch (Notification.permission) {
        case 'granted':
          this.$messaging.getToken().then(messageToken => {
            this.$store
              .dispatch("user/update", {
                messageToken
              })
              .catch(Util.emptyFn);
          }).catch(err => {
            console.log('Unable to retrieve refreshed token ', err);
          });
          break;
        case 'denied':
          this.seekNotificationPermission = false;
          break;
        default:
          this.seekNotificationPermission = true;
          break;
      }
    }
  },

  watch: {
    "saleResponse.billNumber": {
      handler: function(billNumber) {
        if (!billNumber || this.resourceId) {
          return;
        }
        this.redirectTimeoutFn = setTimeout(() => {
          this.displayHome();
        }, this.redrTime);
      },
      deep: true,
      immediate: true
    },
    "paymentTxn.errorMessage"() {
      const paymentTxn = this.paymentTxn;

      if (
        paymentTxn &&
        paymentTxn.paymentStatus === this.paymentStatusCodes[2] &&
        paymentTxn.errorMessage
      ) {
        Util.notify(this, { message: paymentTxn.errorMessage });
      }
    },
    "paymentTxn.paymentStatus"() {
      const paymentTxn = this.paymentTxn;
      let contactText = this.businessContact
        ? `at ${this.businessContact}`
        : "";

      if (
        this.isExternalPayment &&
        paymentTxn &&
        paymentTxn.paymentStatus === this.paymentStatusCodes[0]
      ) {
        Util.notify(this, {
          message: `Please contact the outlet ${contactText} regarding payment.`
        });
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    const user = localStorage.getItem("currentUser");

    this.clearTimers();
    this.$store.dispatch("cart/resetState");
    if (from.name && from.name.includes("OrderResult")) {
      if (this.resourceId && to.name !== "Outlet") {
        return next({ name: "Outlet" });
      } else if (user && to.name !== "Discovery") {
        return next({ name: "Discovery" });
      }
    }
    next();
  },
  methods: {
    formatPrice(number) {
      return Util.formatPrice(number);
    },
    restart() {
      this.$router.go(-1);
    },
    displayOrderStatus() {
      this.$router.push({ name: "OutletOrderStatus" });
    },
    displayBillLink() {
      window.open(this.saleResponse.url, "_blank");
    },
    clearTimers() {
      clearTimeout(this.redirectTimeoutFn);
    },
    displayHome() {
      this.$router.push({ name: "Discovery" });
    },

    onSeekNotificationPermission() {
      if (!("Notification" in window) || !this.$messaging) return;

      Notification.requestPermission().then(permission => {
        switch (permission) {
          case "granted":
            this.seekNotificationPermission = false;
            this.$messaging.getToken().then(messageToken => {
              this.$store
                .dispatch("user/update", {
                  messageToken
                })
                .catch(Util.emptyFn);
            });
            break;
          case "denied":
            this.seekNotificationPermission = false;
            break;
          default:
            this.seekNotificationPermission = true;
            break;
        }
      });
    }
  }
};
</script>
<style scoped>
/* @import url('https://apps.ristaapps.com/static/css/core.min.css?_dc=1553850036'); */

.vh-50 {
  height: 50vh;
}
.padding-125 {
  padding: 0.125em;
}
</style>
